import { useState, useEffect } from 'react';

export default function useAuth() {
    // **MODIFIED:** The initial state now includes an `isLoading` flag.
    // const [auth, setAuth] = useState({ isLoggedIn: false, userRole: null, isLoading: true });
    const [auth, setAuth] = useState(() => {
        // If we are on localhost (NODE_ENV is 'development'), skip the login.
        if (process.env.NODE_ENV === 'development') {
            return { isLoggedIn: true, userRole: 'admin', isLoading: false };
        }

        // Otherwise, use the normal session check logic for production.
        return { isLoggedIn: false, userRole: null, isLoading: true };
    });

    // **NEW:** This effect runs on initial app load to check for an active session.
    useEffect(() => {
        // --- THIS IS THE FIX ---
        // We only run the server-side session check if we are NOT in development mode.
        // In development, we trust the initial state we set above.
        if (process.env.NODE_ENV !== 'development') {
            const checkSession = async () => {
                try {
                    const response = await fetch('/api/auth/me');
                    if (response.ok) {
                        const user = await response.json();
                        setAuth({ isLoggedIn: true, userRole: user.role, isLoading: false });
                    } else {
                        setAuth({ isLoggedIn: false, userRole: null, isLoading: false });
                    }
                } catch (e) {
                    console.error("Session check failed:", e);
                    setAuth({ isLoggedIn: false, userRole: null, isLoading: false });
                }
            };
            checkSession();
        }
    }, []); // The empty dependency array
    
    const login = async (username, password) => {
        try {
            const response = await fetch('/api/auth/credentials/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password })
            });
            if (!response.ok) {
                throw new Error('Invalid credentials');
            }
            const { role } = await response.json();
            setAuth({ isLoggedIn: true, userRole: role, isLoading: false });
            return role;
        } catch (error) {
            setAuth({ isLoggedIn: false, userRole: null, isLoading: false });
            return null;
        }
    };

    const logout = () => {
        // A full page redirect is best to ensure the server session is cleared.
        window.location.href = '/api/auth/logout';
    };

    return { ...auth, login, logout };
}

